const historyText = () => {
  const containers = document.querySelectorAll('.history-text-container');

  containers.forEach(container => {
    // Toggle butonu: HTML'de varsa onu kullan, yoksa oluştur
    const button = container.parentNode.querySelector('.read-more-btn') || document.createElement('button');
    if (!button.classList.contains('read-more-btn')) {
      button.className = 'read-more-btn';
    }
    const moreLabel = button.getAttribute('data-more') || 'Devamını Oku';
    const lessLabel = button.getAttribute('data-less') || 'Daha Az Göster';

    // İlk metin (buton içinde olmalı): data-more'dan gelsin
    button.textContent = moreLabel;

    let expanded = false;

    const updateButtonVisibility = () => {
      const isOverflowing = container.scrollHeight > container.clientHeight + 1;
      if (isOverflowing && !button.isConnected) {
        container.insertAdjacentElement('afterend', button);
      } else if (!isOverflowing && button.isConnected && !expanded) {
        button.remove();
      }
    };

    button.addEventListener('click', () => {
      expanded = !expanded;
      container.classList.toggle('is-expanded', expanded);
      button.textContent = expanded ? lessLabel : moreLabel;
    });

    // İlk durum kontrolü ve resize'da güncelle
    updateButtonVisibility();
    window.addEventListener('resize', updateButtonVisibility);
  });
};

export default historyText;
